export default __webpack_public_path__ + "0216c569d91dd8dd97816178ce2a1648.png";